module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="apexchat_scripts_text_main_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n  class="livechat_message_wrapper apexchat_question_type_custom_style_div apexchat_question_type_confirm_or_skip apexchat_message';
 if(userId == -1){ ;
__p += ' apexchat_system';
};

 if(userId == 0){ ;
__p += ' apexchat_visitor';
};

 if(userId > 0 || userId == -3){ ;
__p += ' apexchat_agent';
};
__p += '">\r\n  <form autocomplete="on" name="live_chat_prechat_form_' +
((__t = (id)) == null ? '' : __t) +
'" onsubmit="return false;">\r\n    <div class="apexchat_question_type_single_col">\r\n      <div class="apexchat_speaker">\r\n        <div class="apexchat_question_type_confirm_or_skip" id="apexchat_question_type_div_close_button_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n          <div title="Close" id="apexchat-btn-skip-' +
((__t = (id)) == null ? '' : __t) +
'"\r\n            class="apexchat_question_type_close_button apexchat_element_on_focus"></div>\r\n        </div>\r\n        <!-- <div class="qt-user apexchat_speaker apexchat_participant_display_text" id="apexchat_participant_display_name">\r\n          ' +
((__t = (participantDisplayName )) == null ? '' : __t) +
'\r\n        </div>\r\n        <div class="apexchat_speaker apexchat_participant_display_text" id="apexchat_participant_display_col">:&nbsp\r\n        </div> -->\r\n        <div class="apexchat_text apexchat_participant_display_text" tabindex="0"\r\n          id="apexchat_participant_display_text">\r\n          ' +
((__t = (text )) == null ? '' : __t) +
'\r\n        </div>\r\n      </div>\r\n      <div id="apexchat_question_type_div_confirm_button_' +
((__t = (id)) == null ? '' : __t) +
'" class="apexchat_rd_prechat_input">\r\n        <input type="text" id="apexchat_question_type_text_input_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n          class="apexchat_rd_autoCompleteInupt txtAutocompleteInput" placeholder="Enter your answer">\r\n        <!-- aria-hidden to avoid double reading. -->\r\n        <a id="apexchat-btn-confirm-' +
((__t = (id)) == null ? '' : __t) +
'" tabindex="0" title="Send" role="button"\r\n          class="apexchat_rd_send apexchat_element_on_focus">\r\n          <img class="apexchat_prechat_rd_send_icon" src="' +
((__t = (ApexChatBaseUrl)) == null ? '' : __t) +
'contents/images/ic_send.svg" alt="Send"\r\n            aria-hidden="true">\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>';

}
return __p
}